import gql from 'graphql-tag';

export const apiKey = gql`
  fragment ApiKey on ApiKey {
    id
    name
    createdAt
    userId
  }
`;
